import ClauseNavigationBar from './ClauseNavigationBar';

export default ClauseNavigationBar;
